export default __webpack_public_path__ + "static/media/invisible box.85a3d81f.svg";